(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('LangueController', LangueController);

    LangueController.$inject = ['$scope', '$state', 'Langue', 'TableService'];

    function LangueController($scope, $state, Langue, TableService) {

        var vm = this;
        var addItemData = {
            templateUrl: 'app/entities/langue/langue-dialog.html',
            controller: 'LangueDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'sm',
            resolve: {
                entity: function() {
                    return {
                        nom: null,
                        id: null
                    };
                }
            }
        };



        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/langue/langue-dialog.html',
            controller: 'LangueDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData = {
            templateUrl: 'app/entities/langue/langue-delete-dialog.html',
            controller: 'LangueDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Langue,
            entitySearch: Langue,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();
